import { Component } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCheckDouble, faStar } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { GsapService } from '../../core/services/gsap.service';
import { MasterService } from '../../core/services/master.service';

@Component({
  selector: 'app-arena.component',
  imports: [FontAwesomeModule],
  templateUrl: './arena.component.html',
  styleUrl: './arena.component.scss',
})
export class ArenaComponent {
  faCheck=faCheckDouble;
  faIcon2=faStar;
  faWhatsapp=faWhatsapp;
  
  constructor(
    private gsap: GsapService,
    private _svc_master: MasterService,
  ) {}


  ngOnInit() { 
    //this.gsap.anima_trg('pages-arena.estrutura'); 
  }
  
  navigate(p_to:string): void {
    this._svc_master.navigate(p_to); 
    
  }

}
